<template>
  <div>
    <InformationList/>
  </div>
</template>

<script>
import InformationList from "@/views/Information/components/list.vue";
export default {
components: {InformationList},
  data() {
    return {
      
    };
  },
created() {},
computed: {},
methods: {},
};
</script>

<style scoped lang='scss'>

</style>